'use client';

import { Button } from '@/components/ui/button';

import { cn } from '@/lib/utils';

type PageErrorStateProps = {
	title?: string;
	description?: string;
	actionLabel?: string;
	onAction?: () => void;
	className?: string;
};

export default function PageErrorState({
	title = 'Something went wrong',
	description,
	actionLabel,
	onAction,
	className,
}: PageErrorStateProps) {
	return (
		<div
			className={cn(
				'm-auto flex h-full min-h-[300px] flex-col items-center justify-center gap-3 px-4 py-8 text-center',
				className
			)}
		>
			<div>
				<p className="text-xl font-semibold text-primary">{title}</p>
				{description && <p className="mt-2 text-sm text-secondary">{description}</p>}
			</div>
			{actionLabel && onAction && (
				<Button
					onClick={onAction}
					className="mt-1"
				>
					{actionLabel}
				</Button>
			)}
		</div>
	);
}
